/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import type { Token } from "@/domains/core"
import { veTokenAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type IncreaseLockDurationProps = {
  account: Address
  chainId: number
  config: Config
  vestedToken: Token
  amount: bigint
  secondsToExpire: number
}

export const createLock = async ({
  account,
  chainId,
  config,
  vestedToken,
  amount,
  secondsToExpire,
}: IncreaseLockDurationProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: veTokenAbi as Abi,
        account,
        address: vestedToken.address,
        args: [amount, secondsToExpire],
        chainId,
        functionName: "create_lock",
      },
    })
    return result
  } catch (error: any) {
    console.error("createLock", error)
    return { success: false, error: error.message, code: error.code }
  }
}

/*
const createLock = async ({ web3, amount, secondsToExpire, account, gasPrice, vestedAddress }) => {
  try {
    const options = { from: account }
    if (gasPrice) {
      options["gasPrice"] = gasPrice
    }

    const veTokenContract = new web3.eth.Contract(veTokenAbi, vestedAddress)
    const tx = await veTokenContract.methods.create_lock(amount, secondsToExpire).send(options)
    return { tx, success: true }
  } catch (error: any) {
    console.error("createLock", error)
    // @ts-ignore
    return { tx: null, success: false, error: error.message, code: error.code }
  }
}
*/
